import request from '@/utils/request'

// 调压器列表
export const apiGetPressureRegulatorList = data => {
	return request({
		url: '/monitor/nqi/pressure-regulators/search',
		method: 'POST',
		data,
		pending: true,
		needJointIsolation: true,
	})
}

// 新增调压器
export const apiAddPressureRegulator = data => {
	return request({
		url: '/monitor/nqi/pressure-regulators',
		method: 'POST',
		data,
		pending: true,
		needJointIsolation: true,
	})
}

// 调压器详情
export const apiGetPressureRegulatorDetail = id => {
	return request({
		url: `/monitor/nqi/pressure-regulators/${id}`,
		method: 'GET',
		pending: true,
		needJointIsolation: true,
	})
}

// 编辑调压器
export const apiUpdatePressureRegulator = (id, data) => {
	return request({
		url: `/monitor/nqi/pressure-regulators/${id}`,
		method: 'PUT',
		data,
		pending: true,
		needJointIsolation: true,
	})
}

// 绑定调压器采集器
export const apiBindPressureRegulatorCollector = (id, data) => {
	return request({
		url: `/monitor/nqi/pressure-regulators/bind-collector/${id}`,
		method: 'POST',
		data,
		pending: true,
		needJointIsolation: true,
	})
}

// 解绑调压器采集器
export const apiUnbindPressureRegulatorCollector = id => {
	return request({
		url: `/monitor/nqi/pressure-regulators/unbind-collector/${id}`,
		method: 'POST',
		pending: true,
		needJointIsolation: true,
	})
}

// 未绑定采集器列表
export const apiGetUnboundPressureRegulatorCollectors = params => {
	return request({
		url: '/monitor/nqi/pressure-regulators/unbound-collectors',
		method: 'GET',
		params,
		pending: true,
		needJointIsolation: true,
	})
}

// 采集器详情
export const apiGetPressureRegulatorCollector = params => {
	return request({
		url: '/monitor/nqi/pressure-regulators/collector',
		method: 'GET',
		params,
		pending: true,
		needJointIsolation: true,
	})
}

// 调压器关联设备类型
export const apiGetPressureRegulatorDeviceTypes = params => {
	return request({
		url: '/monitor/nqi/pressure-regulators/device-types',
		method: 'GET',
		params,
		pending: true,
		needJointIsolation: true,
	})
}

// 调压器子设备时点运行数据
export const apiGetPressureRegulatorRuntimeRecords = params => {
	return request({
		url: '/monitor/nqi/pressure-regulators/sub-devices/runtime-records',
		method: 'GET',
		params,
		pending: true,
		needJointIsolation: true,
	})
}

// 调压器子设备清单
export const apiGetPressureRegulatorSubDevices = params => {
	return request({
		url: '/monitor/nqi/pressure-regulators/sub-devices',
		method: 'GET',
		params,
		pending: true,
		needJointIsolation: true,
	})
}

// 调压器告警查询
export const apiGetPressureRegulatorAlarms = params => {
	return request({
		url: '/monitor/nqi/pressure-regulators/alarms',
		method: 'GET',
		params,
		pending: true,
		needJointIsolation: true,
	})
}

// 调压器监控总览
export const apiGetPressureRegulatorMonitorOverview = params => {
	return request({
		url: '/monitor/nqi/pressure-regulator-monitor/overview',
		method: 'GET',
		params,
		pending: true,
		needJointIsolation: true,
	})
}

// 调压器压力趋势
export const apiGetPressureRegulatorPressureRecords = params => {
	return request({
		url: '/monitor/nqi/pressure-regulator-monitor/pressure-records',
		method: 'GET',
		params,
		pending: true,
		needJointIsolation: true,
	})
}

// 调压器流量温度趋势
export const apiGetPressureRegulatorFlowTemperatureTrend = params => {
	return request({
		url: '/monitor/nqi/pressure-regulator-monitor/flow-temperature-trend',
		method: 'GET',
		params,
		pending: true,
		needJointIsolation: true,
	})
}

// 调压器运行画像详情
export const apiGetPressureRegulatorPortraitDetail = params => {
	return request({
		url: '/monitor/nqi/pressure-regulator-portrait/detail',
		method: 'GET',
		params,
		pending: true,
		needJointIsolation: true,
	})
}
